module.exports = __webpack_public_path__ + "img/BASKET_572.00974957.png";